import styled from 'styled-components';
import PrimaryLook from '@assets/images/logo/primary_black_look.svg';
import IconLogo from '@assets/images/logo/icon_black_logo.svg';
import AgregatorLogo from '@assets/images/logo/agregator_black_logo.svg';
import PlatformLogo from '@assets/images/logo/platform_black_logo.svg'; 
import RoomLogo from '@assets/images/logo/room_black_logo.svg';
import PammLogo from '@assets/images/logo/pamm_black_logo.svg'; 
import { GatsbyImage } from "gatsby-plugin-image"

export const PrimaryLookImg = styled(PrimaryLook)`
  margin-top: 67px;
  margin-left: 102px;
`;

export const IconLogoImg = styled(IconLogo)`
  margin-top: 40px;
  margin-left: 120px;
`;

export const OfficeImg = styled(GatsbyImage)`
  width: 482px;
  height: 543px;
`;

export const AgregatorLogoImg = styled(AgregatorLogo)`
`;

export const PlatformLogoImg = styled(PlatformLogo)`
`;

export const RoomLogoImg = styled(RoomLogo)`
`;

export const PammLogoImg = styled(PammLogo)`
`;
